import React, { FC, useEffect, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import moment from 'moment';

import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox } from 'devextreme-react';
import { Popup } from 'devextreme-react';

import { setInvoice } from 'bus/report/actions';
import { InvoiceParams } from 'bus/report/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

type Props = {
  visible: boolean;
  onClose: () => void;
  dataRepost: InvoiceParams;
};

const ReportModal: FC<Props> = ({ visible, onClose, dataRepost }) => {
  let validationRef = useRef<ValidationGroup>(null);
  const dispatch = useDispatchPromise();

  const [form, setForm] = useState<InvoiceParams>({
    date: moment(new Date()).format('YYYY-MM-DD'),
    nomenclature: '',
    quantity: 1,
  });

  useEffect(() => {
    if (dataRepost) {
      setForm(dataRepost);
    }
  }, [dataRepost]);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (validationRef.current?.instance.validate().isValid) {
      await dispatch(setInvoice.async(form));
      onClose();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={onClose}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Отчет"
        width={400}
        onHidden={onClose}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={validationRef}>
                <Form id="report" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFiledBox label="Дата" labelTop>
                      <DateBox
                        stylingMode="underlined"
                        type="datetime"
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, date: e as string }));
                        }}
                        useMaskBehavior
                        dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                        value={form.date}
                      ></DateBox>
                    </AppFiledBox>
                    <AppFiledBox label="Номенклатура" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.nomenclature}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, nomenclature: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле номенклатура" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <AppFiledBox label="Объем" labelTop requere>
                      <NumberBox
                        stylingMode="underlined"
                        placeholder="Объем"
                        format="###0.##"
                        value={form.quantity}
                        onValueChanged={(e) => {
                          setForm((prev) => ({ ...prev, quantity: e.value }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Объем" />
                        </Validator>
                      </NumberBox>
                    </AppFiledBox>
                  </Item>
                </Form>

                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={onClose}
                  textConfirm="Скачать"
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ReportModal;
